import React, { useRef, useState } from "react";
import Card from "../../../components/Card/Card";
import List from "../../../components/List/List";
import Pagination from "../../../components/Pagination/Pagination";
import { useUserStore } from "../../../contexts/userStore";
import { AutomationTypeEnum } from "../../../enums/automationTypes";
import AutomationButtonService from "../../../services/AutomationButtonService";
import "./ListAutomationButtons.css";

const ListAutomationButtons = (props) => {
	const [automationButtons, setAutomationButtons] = useState([]);
	const [maxPage, setMaxPage] = useState(1);
	const { selectedCondominio } = useUserStore();
	const [collumnClicked, setCollumnClicked] = useState({
		collumnTitle: "id",
		orderDirection: "DESC",
	});
	const [currentPage, setCurrentPage] = useState(1);
	const [isLoading, setIsLoading] = useState(true);
	const cancelTokenRef = useRef(null);

	const getAutomationButtons = async (
		page,
		searchText,
		selectedCondominio,
		collumnClicked
	) => {
		if (selectedCondominio === 0) return;
		if (cancelTokenRef.current) {
			cancelTokenRef.current.abort();
		}
		cancelTokenRef.current = new AbortController();
		setIsLoading(true);
		const response =
			await AutomationButtonService.listAutomationButtonsByCondominiumPaginated(
				page,
				searchText,
				selectedCondominio,
				collumnClicked
			);
		setIsLoading(false);
		setAutomationButtons(response.data?.items);
		setMaxPage(response.data?.meta?.totalPages);
	};

	React.useEffect(() => {
		getAutomationButtons(currentPage, props.filters, selectedCondominio, collumnClicked);
	}, [
		props.filters,
		selectedCondominio,
		collumnClicked,
		props.refreshKey,
		currentPage
	]);

	// Trata os dados para exibir corretamente na List
	const treatedAutomationButtons = automationButtons?.map((item) => ({
		...item,
		tipo:
			item.type === AutomationTypeEnum.var
				? "Variável"
				: item.type === AutomationTypeEnum.pgm
					? "PGM"
					: "PGM IP",
		nome_variavel:
			item.type === AutomationTypeEnum.var
				? item.automation_variable_name || "-"
				: "-",
		valor_variavel:
			item.type === AutomationTypeEnum.var
				? item.automation_variable_number ?? "-"
				: "-",
		posicao_pgm:
			item.type === AutomationTypeEnum.pgm ||
				item.type === AutomationTypeEnum.pgm_ip
				? item.pgm_position ?? "-"
				: "-",
	}));

	const collumsObjIndex = [
		{
			collumnLabel: "Descrição",
			index: "automation_description",
			type: "text",
		},
		{
			collumnLabel: "Tipo",
			index: "tipo",
			type: "text",
		},
		{ collumnLabel: "Ícone", index: "icon", type: "icon" },
		{
			collumnLabel: "Cor", index: "color", type: "custom", custom: ({ row }) => {
				return <span style={{ width: "15px", height: "15px", display: "block", borderRadius: "var(--borderRadius)", backgroundColor: row.color }} />
			}
		},
		{
			collumnLabel: "Nome Variável",
			index: "nome_variavel",
			type: "text",
		},
		{
			collumnLabel: "Valor Variável",
			index: "valor_variavel",
			type: "text",
		},

		{
			collumnLabel: "Posição PGM",
			index: "posicao_pgm",
			type: "text",
		},
	];

	return (
		<React.Fragment>
			<div className="list-container list-visibility">
				<List
					isLoading={isLoading}
					handleCollumnTitleClick={(collumnIndex) =>
						setCollumnClicked(collumnIndex)
					}
					listEntityName="AutomationButtons"
					collumsObjIndex={collumsObjIndex}
					data={treatedAutomationButtons}
				/>
			</div>
			<div className="card-visibility">
				{automationButtons &&
					automationButtons.map((automationButton, index) => (
						<Card
							key={index}
							delete={() =>
								AutomationButtonService.deleteAutomationButton(
									automationButton.id
								)
							}
							navigateOnDelete={"../consulta-automation-buttons"}
							navigateOnEdit={"../cadastro-automation-buttons"}
							data={automationButton}
						>
							<p className="card-content-title">
								{automationButton.automation_description}
							</p>
							<p className="card-content">
								Tipo:{" "}
								{automationButton.type === AutomationTypeEnum.var
									? "Variável"
									: automationButton.type === AutomationTypeEnum.pgm
										? "PGM"
										: "PGM IP"}
							</p>
							{automationButton.type === AutomationTypeEnum.var && (
								<>
									<p className="card-content">
										Nome Variável:{" "}
										{automationButton.automation_variable_name || "-"}
									</p>
									<p className="card-content">
										Valor Variável:{" "}
										{automationButton.automation_variable_number ?? "-"}
									</p>
								</>
							)}
							{automationButton.type === AutomationTypeEnum.pgm && (
								<>
									<p className="card-content">
										Endereço: {automationButton.address ?? "-"}
									</p>
									<p className="card-content">
										Posição PGM: {automationButton.pgm_position ?? "-"}
									</p>
								</>
							)}
							{automationButton.type === AutomationTypeEnum.pgm_ip && (
								<>
									<p className="card-content">
										Serial: {automationButton.serial || "-"}
									</p>
									<p className="card-content">
										Posição PGM IP: {automationButton.pgm_position ?? "-"}
									</p>
								</>
							)}
						</Card>
					))}
			</div>
			<Pagination
				rowsPerPage={8}
				maxPage={maxPage}
				changePage={(page) =>
					setCurrentPage(page)
				}
			/>
		</React.Fragment>
	);
};

export default ListAutomationButtons;
